import { CSSProperties } from "react";

interface IconsProps {
  fill?: string;
  height?: string;
  onClick?: () => void;
  stroke?: string;
  style?: CSSProperties;
  width?: string;
}

export const SearchIcon = (props: IconsProps): JSX.Element => (
  <svg viewBox="0 0 16.1 15.79" {...props}>
    <g data-name="&lt;Group&gt;" id="_Group_">
      <path
        className="cls-1"
        d="M5.9,11.38a5.63,5.63,0,1,1,5.63-5.63A5.63,5.63,0,0,1,5.9,11.38Zm0-9.75A4.13,4.13,0,1,0,10,5.75,4.13,4.13,0,0,0,5.9,1.62Z"
      />
    </g>
    <polygon
      className="cls-1"
      points="14.4 15.29 8.26 9.3 9.1 8.48 15.24 14.47 14.4 15.29"
    />
  </svg>
);

export const FilledChevron = (props: IconsProps): JSX.Element => (
  <svg viewBox="0 0 32 32" {...props}>
    <defs>
      <rect height="158" id="path-1" rx="8" width="312" x="0" y="0"></rect>
    </defs>
    <g fill="none" fillRule="evenodd" id="Page-1" stroke="none" strokeWidth="1">
      <g
        id="athlete-page---highschool---futurecast-+-announcing-+-previously-committed-to---small-desktop"
        transform="translate(-964.000000, -1771.000000)"
      >
        <rect fill="#FFFFFF" height="5179" width="1024" x="0" y="0"></rect>
        <g
          id="card-/-news-/-small"
          transform="translate(660.000000, 1708.000000)"
        >
          <mask fill="white" id="mask-2">
            <use xlinkHref="#path-1"></use>
          </mask>
          <rect
            height="157"
            rx="8"
            stroke="#D9D9D9"
            width="311"
            x="0.5"
            y="0.5"
          ></rect>
        </g>
        <g id="Group-2" transform="translate(960.000000, 1767.000000)">
          <circle cx="20" cy="20" fill="#0D74CF" id="Oval" r="20"></circle>
          <g
            fill="#FFFFFF"
            id="icn-/-chevron-/-forward"
            transform="translate(4.000000, 4.000000)"
          >
            <polygon
              id="svg"
              points="20.4142136 21.2928932 19 22.7071068 12.2928932 16 19 9.29289322 20.4142136 10.7071068 15.1213203 16"
              transform="translate(16.353553, 16.000000) scale(-1, 1) translate(-16.353553, -16.000000) "
            ></polygon>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
